/*
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-11 10:17:09
 * @Description:
 */
let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 学生列表 https://yapi.aixuexi.com/project/42/interface/api/182075
  studentList: `${baseUrl}/base/insStudentList`,
  // 课程权益---按机构权益类型查询 https://yapi.aixuexi.com/project/42/interface/api/196985
  insQuota: `${baseUrl}/cardequity/ins/quota`,
  // 更换权益 https://yapi.aixuexi.com/project/42/interface/api/196994
  updRight: `${baseUrl}/jurisdiction/audit/initiateStudentJurisdiction`,
  // 角色的权益列表
  rightList: `${baseUrl}/jurisdiction/audit/list`,
  // 权益消耗审核
  rightApproval: `${baseUrl}/jurisdiction/audit/submit`,
  // 权益类型
  xkhCardType: `${baseUrl}/cardequity/cardType`,
  // 权益获取记录查询
  getLogList: `${baseUrl}/cardequity/pageList`,
  batchReject: `${baseUrl}/jurisdiction/batch/reject`,
  batchPass: `${baseUrl}/jurisdiction/batch/pass`,
  // 次卡权益审核列表
  ciCardList: `${baseUrl}/jurisdiction/audit/cicardlist`
}
